import { z } from 'zod';

export const SavedViewScope = { LEADS: 'LEADS', PIPELINE: 'PIPELINE' } as const;
export type SavedViewScope = (typeof SavedViewScope)[keyof typeof SavedViewScope];

export const savedViewSchema = z.object({
  name: z.string().trim().min(2, 'Ponle un nombre a la vista').max(60),
  scope: z.nativeEnum(SavedViewScope),
  /** Filtros tal como viajan en la URL (clave → valor). */
  filters: z.record(z.string()).default({}),
  /** Columnas visibles (solo LEADS). */
  columns: z.array(z.string()).optional().nullable(),
  /** Visible para toda la empresa. */
  isShared: z.boolean().default(false),
  companyId: z.string().uuid().optional().nullable(),
});
export type SavedViewInput = z.infer<typeof savedViewSchema>;
export type SavedViewPayload = z.input<typeof savedViewSchema>;

export interface SavedViewDto {
  id: string;
  name: string;
  scope: SavedViewScope;
  filters: Record<string, string>;
  columns: string[] | null;
  isShared: boolean;
  isOwner: boolean;
  ownerName: string | null;
  companyId: string | null;
  createdAt: string;
}
